import React from "react";
import { Text, Button } from "@mantine/core";
import { useTranslation } from "react-i18next";
import "./QuestionnaireTableItem.css"
import {SimpleQuestionnaire} from "../../types/SimpleQuestionnaire";

export type QuestionnaireTableItemProps = {
  simpleQuestionnaire: SimpleQuestionnaire;
  onEditClicked: () => void;
};

export const QuestionnaireTableItem = (props: QuestionnaireTableItemProps): JSX.Element => {
  const { t } = useTranslation();
  const simpleQuestionnaire = props.simpleQuestionnaire;
  const onEditClicked = props.onEditClicked;
  return (
    <>
      <tr key={simpleQuestionnaire.id}>
        <td>{<Text className="columnId">{simpleQuestionnaire.id}</Text>}</td>
        <td>{<Text className="columnStatus">{simpleQuestionnaire.status}</Text>}</td>
        <td>{<Text className="columnName">{simpleQuestionnaire.title}</Text>}</td>
        <td>{<Text className="columnDescription">{simpleQuestionnaire.description}</Text>}</td>
        <td>{<Text className="columnUuid">{simpleQuestionnaire.uuid}</Text>}</td>
        <td>
          <Button
            onClick={() => {
              onEditClicked?.();
            }}
          >
            {t("Edit")}
          </Button>
        </td>
      </tr>
    </>
  );
};
